import { showError } from '#shared/lib/toast';
import { api } from '../api';
import type { GetValueByPathResponses, SettingsLeafPaths } from '../types';

export function getSettingPatchFunction<Path extends SettingsLeafPaths>(path: Path) {
    return async (body: GetValueByPathResponses[Path]) => {
        try {
            await api.endpoints.patchValueByPath.mutate({ body, path });

            return true;
        } catch (error) {
            showError({ label: 'Не удалось обновить настройки' }, error);

            return false;
        }
    };
}
